import { render } from "./icon.vue?vue&type=template&id=1a85d398"
import script from "./icon.vue?vue&type=script&lang=js"
export * from "./icon.vue?vue&type=script&lang=js"

import "./icon.vue?vue&type=style&index=0&id=1a85d398&lang=css"

import exportComponent from "/usr/lib/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__